import z from 'zod';

export const CustomerAppType = z.enum(['edeka-app', 'marktkauf-app']);
export type CustomerAppType = z.infer<typeof CustomerAppType>;
